import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import api, { formatGBP, formatDateUK, apiError } from "@/lib/api";
import { toast } from "sonner";
import { ArrowLeft, ChevronRight } from "lucide-react";

const LABEL = { purchase: "Purchase", expense: "Expense", z_closing: "Z report", cash_closing: "Cash" };

export default function ReviewQueuePage() {
  const navigate = useNavigate();
  const { user, activeStoreId } = useAuth();
  const allowed = ["owner", "accountant", "store_manager"].includes(user?.role);
  const [items, setItems] = useState(null);
  useEffect(() => {
    if (!allowed) { return; }
    const q = activeStoreId && activeStoreId !== "all" ? `?store_id=${activeStoreId}` : "";
    api.get(`/review/queue${q}`).then((r) => setItems(r.data)).catch((e) => { toast.error(apiError(e)); setItems([]); });
  }, [allowed, activeStoreId]);
  if (!allowed) return <p className="text-sm text-navy/50" data-testid="review-not-available">Only managers, the accountant and the owner review records.</p>;
  return (
    <div className="space-y-4" data-testid="review-queue-page">
      <div className="flex items-center gap-3">
        <button onClick={() => navigate("/dashboard")} className="min-w-[44px] min-h-[44px] flex items-center justify-center text-navy/40" aria-label="Back" data-testid="review-back-btn"><ArrowLeft className="w-5 h-5" /></button>
        <h1 className="text-xl font-heading font-bold text-navy">Waiting for a manager</h1>
      </div>
      {items === null && <p className="text-sm text-navy/50" data-testid="review-loading">Loading…</p>}
      {items?.length === 0 && <p className="text-sm text-navy/50" data-testid="review-empty">Nothing is waiting for review.</p>}
      {items?.map((i) => (
        <button key={`${i.type}-${i.id}`} onClick={() => navigate(i.path)} data-testid={`review-item-${i.type}-${i.id}`}
          className="w-full text-left rounded-xl border border-navy/10 bg-white p-4 flex items-center gap-3 transition-colors hover:bg-navy/5">
          <div className="flex-1 min-w-0">
            <p className="text-xs text-navy/50">{LABEL[i.type]} · {i.store} · {i.date ? formatDateUK(i.date) : ""}</p>
            <p className="text-sm font-semibold text-navy truncate">{i.title}</p>
            <p className="text-xs text-amber-700">{i.why}</p>
          </div>
          <span className="font-mono text-sm text-navy">{formatGBP(i.amount)}</span>
          <ChevronRight className="w-4 h-4 text-navy/30" />
        </button>
      ))}
    </div>
  );
}
